export default Object.freeze({
	middle: 0,
	right: 1,
	left: 2,
	panels: 3
})
